import http from '@/utils/http';
import { SLD } from '@/utils/INTERFACE';
import $ from 'jquery'
import { getSystem } from '../utils/site';
import { getTerminal } from '../utils/page';

const TerminalIds={
    pc:0,
    app:1,
    mob:2,
}

function getChannelFlag(){
    let sys = getSystem()
    let terminal=getTerminal()
    let channelFlag
    if(sys=='ept'){
        channelFlag=TerminalIds[terminal]
    }
    if(sys=='th'){
        channelFlag=1
    }
    return channelFlag
}

export async function isFavor(){
    let res=await http.jsonp.get(`${SLD().rest}/shop/existInFavorite`,{
        venderId:$('#J_venderId').val(),
        channelFlag:getChannelFlag(),
    })
    if(!res.result){
        throw new Error(res.message)
    }
    return res.isFavoriteShop
}

export async function favor(){
    let res=await http.jsonp.get(`${SLD().rest}/shop/favoriteShop`,{
        venderId:$('#J_venderId').val(),
        channelFlag:getChannelFlag(),
    })
    if(!res.result){
        throw new Error(res.message)
    }
}

export async function removeFavor(){
    let res=await http.jsonp.get(`${SLD().rest}/shop/removeFavorite`,{
        venderId:$('#J_venderId').val(),
        channelFlag:getChannelFlag(),
    })
    if(!res.result){
        throw new Error(res.message)
    }
}